var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vl-layer-tile',{attrs:{"z-index":_vm.zIndex}},[_c('vl-source-wms',{ref:"wmsLayer",attrs:{"layers":_vm.layer.layerId,"url":_vm.url,"server-type":"geoserver"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }